import { render, staticRenderFns } from "./mobileIndex.vue?vue&type=template&id=5fc12304&scoped=true&"
import script from "./mobileIndex.vue?vue&type=script&lang=js&"
export * from "./mobileIndex.vue?vue&type=script&lang=js&"
import style0 from "./mobileIndex.vue?vue&type=style&index=0&id=5fc12304&prod&lang=sass&"
import style1 from "./mobileIndex.vue?vue&type=style&index=1&id=5fc12304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc12304",
  null
  
)

export default component.exports